/**
 * Breadcrumbs
 * 
 * @Author: Focci
 * @Date: 2023-06-05 15:51:10
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-05 15:51:10
 */

'use client'

import * as routeCommon from '@lib/route/common'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useLocale, useTranslations } from 'next-intl'
import Link from 'next/link'
import PropTypes from 'prop-types'
import RouteBack from './RouteBack'

export default function StyledBreadcrumbs({
  options = [],
  home = true,
  showBack = true,
  showBreadcrumbs = true,
  prefix,
  onClick = () => {}
}) {
  const locale = useLocale()
  const tc = useTranslations('common')

  return (
    <div className="flex items-center leading-none">
      {showBack && (
        <RouteBack className="bordder-none md:border-r pr-2 mr-2 text-c66" />
      )}
      {prefix}
      {showBreadcrumbs && (
        <div className="hidden lg:flex items-center">
          {
            home && (
              <Link 
                href={routeCommon.home(locale)}
                className="whitespace-nowrap text-c66 hover:text-primary"
              >
                {tc('hougardenHome')}
              </Link>
            )
          }
          {
            options.map((option) => {
              if(option.url) {
                return (
                  <div className="flex items-center" key={option.label + option.url}>
                    <NavigateNextIcon sx={{ fontSize: '.8rem' }} className="text-helper" />
                    <Link 
                      href={option.url}
                      className="whitespace-nowrap text-c66 hover:text-primary"
                      onClick={() => onClick(option)}
                    >
                      {option.label}
                    </Link>
                  </div>
                )
              }
              return (
                <div className="flex items-center" key={option.label + option.url}>
                  <NavigateNextIcon sx={{ fontSize: '.8rem' }} className="text-helper" />
                  <span className="text-c66 line-clamp-1">
                    {option.label}
                  </span>
                </div>
              )
            })
          }
        </div>
      )}
    </div>
  )
}

StyledBreadcrumbs.propTypes = {
  options: PropTypes.array,
  home: PropTypes.bool,
  showBack: PropTypes.bool,
  showBreadcrumbs: PropTypes.bool,
  prefix: PropTypes.node,
}
